import { ReactNode } from 'react';
import i18n from 'i18n/config';
import { PaginationItemProps } from '../components/PaginationItem';

type ItemConfig = {
  key: string;
  disabled?: boolean;
  active?: boolean;
  className?: string;
  content: ReactNode;
  onClick?: () => void;
};

export const getItemConfig = ({
  item,
  currentPage,
  totalPages,
  onChange,
}: PaginationItemProps): ItemConfig | null => {
  switch (item) {
    case 'prev': {
      const disabled = currentPage === 1;

      return {
        key: 'prev',
        disabled,
        className: 'previous',
        content: (
          <span>
            <em className="icon ni ni-back-ios mr-2" />
            {i18n.t('Prev') as string}
          </span>
        ),
        onClick: () => onChange(currentPage - 1),
      };
    }

    case 'next': {
      const disabled = currentPage === totalPages;

      return {
        key: 'next',
        disabled,
        className: 'next',
        content: (
          <span>
            {i18n.t('Next') as string}
            <em className="icon ni ni-forward-ios ml-2" />
          </span>
        ),
        onClick: () => onChange(currentPage + 1),
      };
    }

    case 'ellipsis':
      return {
        key: 'ellipsis',
        disabled: true,
        className: 'ellipsis',
        content: '…',
      };

    default: {
      if (typeof item !== 'number') return null;

      const active = item === currentPage;

      return {
        key: String(item),
        active,
        content: item,
        onClick: () => onChange(item),
      };
    }
  }
};
